export const STORAGE_KEYS = {
  PORTFOLIO_TABLE_COLUMNS: 'portfolio_table_columns',
  ORGANISATIONS_TABLE_COLUMNS: 'organisations_table_columns',
  DEALS_TABLE_COLUMNS: 'deals_table_columns',
  DEALS_DETAILS_COLUMNS: 'deals_details_columns',
  TRANSACTIONS_REPORT_DETAILS_COLUMNS: 'transactions_report_columns',
  CURRENT_PROFILE_ID: 'current_profile_id',
  CURRENT_PROFILE: 'current_profile',
  HAS_SEEN_KYC_REMINDER: 'has_seen_kyc_reminder',
  PLATFORM_TERMS: 'platform_terms',
  PLATFORM_PRIVACY_POLICY: 'platform_privacy_policy',
  INVITED_EMAIL: 'invited_email',
  USERS_TABLE_COLUMNS: 'users_table_columns',
  SUBSCRIBERS_TABLE_COLUMNS: 'subscribers_table_columns',
  KYC_REVIEWS_TABLE_COLUMNS: 'kyc_reviews_table_columns',
  KYCS_TABLE_COLUMNS: 'kycs_table_columns',
  SIDEBAR_SIZE: 'sidebar_size',
  ACCOUNT_MEMBERS_TABLE_COLUMNS: 'account_members_table_columns',
  PREFERRED_PROFILE_ID: 'preferred_profile_id',
} as const

export const LOCAL_STORAGE_KEYS = {
  TOKEN: 'token',
  ORGANISATION_ID: 'organisationId',
} as const
